import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import classNames from "utils/class-names";
import { FILTER_TYPE } from "utils/constants";
import { AiFillBell } from "react-icons/ai";

const convertTimestampToDate = (timestamp) => {
  if (isNaN(timestamp)) {
    return "Invalid Date";
  }

  const date = new Date(timestamp * 1000);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const formattedHours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
};

const InvestigationBarcodeCell = ({
  row,
  subFranchise,
  fIsSuperFranchise,
  fIsFranchiseEmployee,
  setCurrentRowData,
  openObservationValue,
  openSampleCollection,
  setIsOpenApproved,
}) => {
  const { investigation_data } = row.original;
  const { package_obj } = investigation_data;
  const [copied, setCopied] = useState(false);

  const handleClick = () => {
    setCurrentRowData(row?.original);
  };

  const handleCopy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const barcode = investigation_data?.barcode_no || "";
    navigator.clipboard.writeText(barcode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <span>
      <a
        onClick={(e) => {
          e.preventDefault();
          setIsOpenApproved(false);
          if (
            subFranchise === 1 ||
            fIsSuperFranchise === 1 ||
            fIsFranchiseEmployee === 1
          ) {
            handleClick();
          } else {
            if (
              row.original.investigation_data.status !== "PENDING" &&
              row.original.investigation_data.status !== "COLLECTED"
            ) {
              openObservationValue(row.original);
            } else {
              openSampleCollection(row.original);
            }
          }
        }}
        style={{
          fontWeight: "700",
          textDecoration: "underline",
          cursor: "pointer",
          display: "inline-block",
          maxWidth: "150px",
          wordWrap: "break-word",
          whiteSpace: "normal",
        }}
      >
        {package_obj?.package_name || ""} <br />
        {investigation_data?.investigation_name || ""} <br />
        {investigation_data?.barcode_no || ""}
      </a>

      {investigation_data?.barcode_no && (
        <span
          onClick={handleCopy}
          title={copied ? "Copied!" : "Copy Barcode"}
          style={{
            marginLeft: "6px",
            cursor: "pointer",
            color: copied ? "green" : "#555",
            verticalAlign: "middle",
          }}
        >
          {copied ? (
            "✓"
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
            </svg>
          )}
        </span>
      )}
    </span>
  );
};

export const DOCUMENT_COLUMNS_DATA = ({
  openObservationDetails,
  downloadInvestigationDocument,
  openPatientDetails,
  openObservationValue,
  openSampleCollection,
  filters,
  fIsSuperFranchise,
  subFranchise,
  fIsFranchiseEmployee,
  toggleSelectAll,
  selectedRows,
  editableRows,
  setEditableRows,
  toggleSelectRow,
  data,
  setCurrentRowData,
  openDownloadPdf,
  openDownloadPdfSuccessFully,
  directDownloadPdfSuccessFully,
  openHtml,
  handleUploadAttachmentWithObservation,
  setIsOpenApproved,
  processedData,
}) => {
  const employeecodeid = localStorage.getItem("employee_code_id");
  return [
    {
      Header: "S.No",
      accessor: "_index",
      disableSortBy: true,
      Cell: ({ row }) => {
        const isUrgent = row.original.investigation_data?.urgent;
        return (
          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            {row.index + 1}
            {isUrgent && <AiFillBell color="red" />}
          </span>
        );
      },
    },
    {
      Header: "Appointment Details",
      accessor: "registration_details",
      disableSortBy: true,
      Cell: ({ row }) => {
        const { generated, appointment_id } = row.original;
        const [copied, setCopied] = React.useState(false);

        const handleCopy = (e) => {
          e.preventDefault();
          e.stopPropagation();

          if (!appointment_id) return;

          navigator.clipboard.writeText(appointment_id).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
          });
        };

        return (
          <span>
            {appointment_id && (
              <>
                <span>{appointment_id}</span>

                <span
                  onClick={handleCopy}
                  title={copied ? "Copied!" : "Copy Appointment ID"}
                  style={{
                    marginLeft: "6px",
                    cursor: "pointer",
                    color: copied ? "green" : "#555",
                    verticalAlign: "middle",
                  }}
                >
                  {copied ? (
                    "✓"
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                    </svg>
                  )}
                </span>

                <br />
              </>
            )}

            {generated && <>{convertTimestampToDate(generated)}</>}
          </span>
        );
      },
    },
    {
      Header: "Patient Name",
      accessor: "patient_name",
      disableSortBy: true,
      Cell: ({ row }) => {
        // return <span>{row?.original?.patient_name || "-"}</span>;
        const patientName = processedData[row.index]?.patient_name_display;
        if (!patientName) return null;

        return (
          <span
            style={{
              wordWrap: "break-word",
              whiteSpace: "normal",
              display: "block",
            }}
          >
            {patientName}
          </span>
        );
      },
    },
    {
      Header: "Age, Gender & Doctor Name",
      accessor: "age_gender",
      disableSortBy: true,
      Cell: ({ row }) => {
        const ageGender = processedData[row.index]?.age_gender_display;
        const doctorName = processedData[row.index]?.refer_doctor_name_display;

        if (!ageGender && !doctorName) return null;

        return (
          <span
            style={{ textTransform: "capitalize", display: "inline-block" }}
          >
            {ageGender}
            {doctorName && (
              <>
                <br />
                {doctorName}
              </>
            )}
          </span>
        );
      },
    },
    {
      Header: "Panel",
      accessor: "company_name",
      disableSortBy: true,
      Cell: ({ row }) => {
        const companyName = processedData[row.index]?.company_name_display;
        if (!companyName) return null;

        return (
          <span
            style={{
              display: "inline-block",
              maxWidth: "150px",
              wordWrap: "break-word",
              whiteSpace: "normal",
              lineHeight: "1.2",
            }}
          >
            {companyName}
          </span>
        );
      },
    },
    {
      Header: "Investigation & Barcode",
      accessor: "investigation_barcode",
      disableSortBy: true,
      Cell: ({ row }) => (
        <InvestigationBarcodeCell
          row={row}
          subFranchise={subFranchise}
          fIsSuperFranchise={fIsSuperFranchise}
          fIsFranchiseEmployee={fIsFranchiseEmployee}
          setCurrentRowData={setCurrentRowData}
          openObservationValue={openObservationValue}
          openSampleCollection={openSampleCollection}
          setIsOpenApproved={setIsOpenApproved}
        />
      ),
    },
    {
      Header: (
        <input
          type="checkbox"
          onChange={(e) => toggleSelectAll(e.target.checked)}
          checked={
            selectedRows?.length > 0 &&
            selectedRows?.length ===
              data?.filter(
                (row) =>
                  // row.investigation_data?.status === "RESULT_DONE" ||
                  row.investigation_data?.status === "APPROVED" ||
                  row.investigation_data?.status === "REPORT_ISSUED" ||
                  row.investigation_data?.status === "NOT_APPROVED",
                //  || row.investigation_data?.status === "REJECTED"
              ).length &&
            data?.filter(
              (row) =>
                // row.investigation_data?.status === "RESULT_DONE" ||
                row.investigation_data?.status === "APPROVED" ||
                row.investigation_data?.status === "REPORT_ISSUED" ||
                row.investigation_data?.status === "NOT_APPROVED",
              // || row.investigation_data?.status === "REJECTED"
            ).length > 0
          }
          indeterminate={
            selectedRows?.length > 0 &&
            selectedRows?.length <
              data?.filter(
                (row) =>
                  // row.investigation_data?.status === "RESULT_DONE" ||
                  row.investigation_data?.status === "APPROVED" ||
                  row.investigation_data?.status === "REPORT_ISSUED" ||
                  row.investigation_data?.status === "NOT_APPROVED",
                // || row.investigation_data?.status === "REJECTED"
              ).length
              ? true
              : undefined
          }
        />
      ),
      accessor: "_select",
      disableSortBy: true,
      Cell: ({ row }) => {
        const rowIndex = row?.index;
        const isChecked = selectedRows.includes(rowIndex);
        const { investigation_data } = row.original;
        const status = investigation_data?.status;

        return (
          // status === "RESULT_DONE" ||
          (status === "APPROVED" ||
            status === "REPORT_ISSUED" ||
            status === "NOT_APPROVED") && (
            // || status === "REJECTED"
            <input
              type="checkbox"
              onChange={() => toggleSelectRow(rowIndex, row.original)}
              checked={isChecked}
            />
          )
        );
      },
    },
    {
      Header: "",
      accessor: "ids",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return (
          <>
            <button
              disabled={!filters.is_active}
              className={classNames("btn dropdown-toggle", {
                "btn-primary": filters.is_active,
                "btn-secondary": !filters.is_active,
              })}
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onClick={(e) => e.stopPropagation()}
            >
              More...
            </button>
            <ul className="dropdown-menu">
              {/* {fIsSuperFranchise !== 1 &&
                fIsFranchiseEmployee !== 1 &&
                subFranchise !== 1 && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => {
                        openObservationValue(cell.row.original);
                      }}
                    >
                      Add Observation Value
                    </button>
                  </li>
                )} */}
              {/* {["APPROVED", "REPORT ISSUED", "RESULTDONE"].includes(
                filters?.app_status
              ) && ( */}
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => openObservationDetails(cell.row.original)}
                >
                  View
                </button>
              </li>
              <li>
                <Link
                  to="/patient-document"
                  state={{ patientData: cell.row.original }}
                  className="dropdown-item"
                >
                  Show Patient Document
                </Link>
              </li>
              <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    handleUploadAttachmentWithObservation(cell.row.original)
                  }
                >
                  Upload Attachment
                </button>
              </li>
              {/* <li>
                <button
                  className="dropdown-item"
                  onClick={() => downloadInvestigationDocument(cell.row.original)}
                >
                  Investigation Document
                </button>
              </li> */}
              {/* )} */}
              {/* {filters?.app_status !== "PENDING" && (
                <li>
                  <Link
                    to={`/ResultEntryPdf?display_header=true&display_footer_banner=true&display_banner=true&display_footer=true&display_address=true&display_watermark=true&investigation_ids=${cell?.row?.original?.investigation_data?.investigation_id}&appointment_id=${cell?.row?.original?.appointment_id}`}
                    className="acc-link"
                  >
                    <button className="dropdown-item">Show Generate PDF</button>
                  </Link>
                </li>
              )} */}
              {employeecodeid === "1" && (
                <li>
                  <Link
                    to={`/ResultEntryPdf?display_header=true&display_footer_banner=true&display_banner=true&display_footer=true&display_address=true&display_watermark=true&investigation_ids=${cell?.row?.original?.investigation_data?.investigation_id}&appointment_id=${cell?.row?.original?.appointment_id}`}
                    className="acc-link"
                  >
                    <button className="dropdown-item">Show Generate PDF</button>
                  </Link>
                </li>
              )}
              {employeecodeid === "1" && (
                <li>
                  <Link
                    to={`/NewReportPdf?display_header=true&display_footer_banner=true&display_banner=true&display_footer=true&display_address=true&display_watermark=true&investigation_ids=${cell?.row?.original?.investigation_data?.investigation_id}&appointment_id=${cell?.row?.original?.appointment_id}`}
                    className="acc-link"
                  >
                    <button className="dropdown-item">
                      New Report Generate PDF
                    </button>
                  </Link>
                </li>
              )}
              {/* <li>
                <button
                  className="dropdown-item"
                  onClick={() => openDownloadPdf(cell.row.original)}
                >
                  Download PDF
                </button>
              </li> */}
              {/* <li>
                <button
                  className="dropdown-item"
                  onClick={() => openDownloadPdfSuccessFully(cell.row.original)}
                >
                  Generate PDF
                </button>
              </li> */}
              {/* <li>
                <Link
                  to={`/ResultEntryReactPdf?display_header=true&display_footer=true&display_address=true&display_watermark=true&investigation_id=${cell?.row?.original?.investigation_data?.investigation_id}&appointment_id=${cell?.row?.original?.appointment_id}`}
                  className="acc-link"
                >
                  <button className="dropdown-item">Generate React PDF</button>
                </Link>
              </li> */}
            </ul>
          </>
        );
      },
    },
  ];
};

export const ADD_OBSERVATION_COLUMN_DATA = () => {
  return [
    {
      Header: "Observation Name",
      accessor: "observation_name",
      disableSortBy: true,
    },
    {
      Header: "Investigation",
      accessor: "investigation_details.investigation_name",
      disableSortBy: true,
    },
    {
      Header: "Patient Name",
      accessor: "patient_details.patient_name",
      disableSortBy: true,
    },
    {
      Header: "MacReading",
      accessor: "max_critical",
      disableSortBy: true,
    },
  ];
};

export const ADD_OBSERVATION_COLUMNS_DATA = (
  handleValueChange,
  inputRefs,
  numericValueAcceptableObservations,
  checkedInvestigations,
  lastFocusedInput,
  allInputRefs,
  totalInputs,
  refMap,
) => {
  return [
    {
      Header: "Observation Name",
      accessor: "observation_name",
      disableSortBy: true,
      Cell: ({ row }) => {
        const isHeader = row.original.header === true;

        return (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "5px" }}
            >
              <span
                style={{
                  fontWeight: isHeader ? "bold" : "normal",
                  textTransform: isHeader ? "uppercase" : "none",
                  marginLeft: isHeader ? "-12px" : "0px",
                }}
              >
                {row.original.observation_name}
              </span>
            </div>
          </>
        );
      },
    },
    {
      Header: "Value",
      accessor: "observation_value",
      disableSortBy: true,
      Cell: ({ row }) => {
        const isHeader = row.original.header === true;
        const isApproved = row.original.status === "APPROVED";
        const rowIndex = row.index;
        const [localValue, setLocalValue] = React.useState(
          row?.original?.observation_value !== undefined
            ? row.original.observation_value
            : "",
        );
        const [isInitialized, setIsInitialized] = React.useState(false);

        const [showHelp, setShowHelp] = React.useState(false);
        const dropdownRef = React.useRef(null);
        const helpIconRef = React.useRef(null);

        const investigationKey = `${row.original.investigation_details.lab_department.department}-${row.original.investigation_details.investigation_name}`;

        const isInvestigationChecked =
          checkedInvestigations[investigationKey] === true;

        const filteredHelp = row.original.observation_help
          ? row.original.observation_help.filter(
              (help) => help.observation_id === row.original.observation_id,
            )
          : [];

        React.useEffect(() => {
          function handleClickOutside(event) {
            if (
              helpIconRef.current &&
              helpIconRef.current.contains(event.target)
            ) {
              return;
            }

            if (
              dropdownRef.current &&
              !dropdownRef.current.contains(event.target) &&
              showHelp
            ) {
              setShowHelp(false);
            }
          }

          if (showHelp) {
            document.addEventListener("mousedown", handleClickOutside);
          }

          return () => {
            document.removeEventListener("mousedown", handleClickOutside);
          };
        }, [showHelp]);

        React.useEffect(() => {
          const initialValue = row?.original?.observation_value;
          const status = row?.original?.status;
          const machineReading = row?.original?.machine_reading;

          const obsId = row?.original?.observation_id;
          const department =
            row?.original?.investigation_details?.lab_department?.department;
          const investigation =
            row?.original?.investigation_details?.investigation_name;

          if (
            initialValue !== undefined &&
            status === "MAC_DATA" &&
            machineReading !== null &&
            initialValue !== "" &&
            !isInitialized &&
            obsId &&
            department &&
            investigation
          ) {
            const timeoutId = setTimeout(() => {
              handleValueChange(initialValue, department, investigation, obsId);
              setIsInitialized(true);
            }, 0);

            return () => clearTimeout(timeoutId);
          }
        }, [
          row?.original?.observation_value,
          row?.original?.observation_id,
          isInitialized,
          handleValueChange,
        ]);

        React.useEffect(() => {
          if (
            row.original.observation_value !== localValue &&
            document.activeElement !== inputRefs.current[rowIndex]
          ) {
            setLocalValue(
              row?.original?.observation_value !== undefined
                ? row.original.observation_value
                : "",
            );
          }
        }, [row.original.observation_value]);

        const handleKeyDown = (e) => {
          const acceptableKeys = ["Tab", "Enter"];
          // console.log("Pressed Key:", e.key);

          if (!acceptableKeys.includes(e.key)) return;

          // Agar Enter key hai aur filteredHelp available hai, toh dropdown open kar do
          if (e.key === "Enter" && filteredHelp.length > 0) {
            e.preventDefault();
            lastFocusedInput.current = e.target;
            setShowHelp(!showHelp);
            return;
          }

          // Baaki Tab aur Enter ki functionality same rahegi
          if (
            e.key === "Tab" ||
            (e.key === "Enter" && filteredHelp.length === 0)
          ) {
            e.preventDefault();
            const direction = e.key === "Tab" && e.shiftKey ? -1 : 1;
            // console.log("Direction:", direction);

            const currentIndex = inputRefs.current.findIndex(
              (el) => el === document.activeElement,
            );
            // console.log("Current Index:", currentIndex);

            let nextIndex = currentIndex + direction;
            // console.log("Initial Next Index:", nextIndex);

            while (!inputRefs.current[nextIndex]) {
              // console.log("Skipping invalid input at index:", nextIndex);
              nextIndex += direction;

              if (nextIndex >= inputRefs.current.length) {
                nextIndex = 0;
                // console.log("Wrapped to start:", nextIndex);
              } else if (nextIndex < 0) {
                nextIndex = inputRefs.current.length - 1;
                // console.log("Wrapped to end:", nextIndex);
              }
            }

            // console.log("Focusing on index:", nextIndex);
            inputRefs.current[nextIndex]?.focus();
          }
        };

        const minValue = row.original.min_reading;
        const maxValue = row.original.max_reading;

        const isMinMaxValid =
          minValue !== "" &&
          maxValue !== "" &&
          !(Number(minValue) === 0 && Number(maxValue) === 0);

        const isOutOfRange =
          localValue !== "" &&
          isMinMaxValid &&
          (Number(localValue) < Number(minValue) ||
            Number(localValue) > Number(maxValue));

        const handleChange = (e) => {
          const value = e?.target?.value;
          // console.log(
          //   "**************paste value in observation value**************",
          //   value,
          // );
          // console.log("row.original", row.original);
          setLocalValue(value);
          handleValueChange(
            value,
            row.original.investigation_details.lab_department.department,
            row.original.investigation_details.investigation_name,
            row.original.observation_id,
            // isInitialLoad = false for user input
          );
        };

        const inputType = numericValueAcceptableObservations.includes(
          row.original.observation_id,
        )
          ? "number"
          : "text";

        const helpIconStyle = {
          backgroundColor: "#3b82f6",
          color: "white",
          borderRadius: "50%",
          width: "16px",
          height: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "12px",
          fontWeight: "bold",
          cursor: "pointer",
        };

        if (!isInvestigationChecked) {
          return <span></span>;
        }

        if (isApproved) {
          return (
            <div className="flex items-center">
              <span>{localValue}</span>
            </div>
          );
        }

        const mandatoryStyle = {
          backgroundColor: "#fff5f5",
          color: "black",
          border: "2px solid #ef4444",
          padding: "5px",
          borderRadius: "4px",
          outline: "none",
        };

        const normalStyle = {
          backgroundColor: "white",
          color: "black",
          border: "1px solid #d9d9d9",
          padding: "5px",
          borderRadius: "4px",
          outline: "none",
        };

        const inputStyle =
          row.original.mark_as_mandatory === true &&
          (localValue === "" || localValue === undefined || localValue === null)
            ? mandatoryStyle
            : isOutOfRange
              ? {
                  backgroundColor: "#f76060",
                  color: "white",
                  border: "1px solid #f76060",
                  padding: "5px",
                  borderRadius: "4px",
                  outline: "none",
                }
              : normalStyle;

        return isHeader ? (
          <span></span>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              position: "relative",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                gap: "5px",
              }}
            >
              <input
                ref={(el) => {
                  if (el && !inputRefs.current.includes(el)) {
                    inputRefs.current.push(el);
                  }
                }}
                type={inputType}
                value={localValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onFocus={(e) => {
                  lastFocusedInput.current = e.target;
                }}
                style={inputStyle}
              />

              {row.original.mark_as_mandatory === true &&
                (localValue === "" ||
                  localValue === undefined ||
                  localValue === null) && (
                  <span
                    style={{
                      color: "#ef4444",
                      fontSize: "12px",
                      marginTop: "4px",
                      display: "block",
                      fontWeight: "500",
                    }}
                  >
                    This field is mandatory
                  </span>
                )}

              {showHelp && (
                <select
                  size={filteredHelp?.length}
                  ref={dropdownRef}
                  className="absolute z-10 bg-white border border-gray-200 rounded shadow-lg p-2 w-64"
                  style={{
                    top: "100%",
                    left: "0",
                    overflowY: "auto",
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      const selectedItem = filteredHelp.find(
                        (item) => item.id.toString() === e.target.value,
                      );
                      if (selectedItem) {
                        const valueToSet =
                          selectedItem.help_value || selectedItem.help_header;
                        setLocalValue(valueToSet);
                        setShowHelp(false);

                        handleValueChange(
                          valueToSet,
                          row.original.investigation_details.lab_department
                            .department,
                          row.original.investigation_details.investigation_name,
                          row.original.observation_id,
                          false,
                        );
                      }

                      setTimeout(() => {
                        lastFocusedInput.current?.focus();
                      }, 0);
                    }
                  }}
                  onClick={(e) => {
                    const selectedItem = filteredHelp.find(
                      (item) => item.id.toString() === e.target.value,
                    );
                    if (selectedItem) {
                      const valueToSet =
                        selectedItem.help_value || selectedItem.help_header;
                      setLocalValue(valueToSet);
                      setShowHelp(false);

                      handleValueChange(
                        valueToSet,
                        row.original.investigation_details.lab_department
                          .department,
                        row.original.investigation_details.investigation_name,
                        row.original.observation_id,
                      );
                    }
                  }}
                  onBlur={() => setShowHelp(false)}
                  autoFocus
                >
                  {filteredHelp.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.help_header}
                    </option>
                  ))}
                </select>
              )}
            </div>

            {filteredHelp.length > 0 && (
              <div className="relative">
                <span
                  ref={helpIconRef}
                  style={helpIconStyle}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowHelp(!showHelp);
                  }}
                >
                  ?
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      Header: "Flag",
      accessor: "flag",
      disableSortBy: true,
      Cell: ({ row }) => {
        const isHeader = row.original.header === true;

        const observationValue = Number(row.original.observation_value);
        const minValue =
          row?.original?.min_reading !== undefined &&
          row?.original?.min_reading !== ""
            ? Number(row.original.min_reading)
            : null;

        const maxValue =
          row?.original?.max_reading !== undefined &&
          row?.original?.max_reading !== ""
            ? Number(row.original.max_reading)
            : null;

        const getFlag = () => {
          if (
            minValue === null ||
            maxValue === null ||
            (minValue === 0 && maxValue === 0)
          ) {
            return "Normal";
          }

          if (observationValue > maxValue) return "High";
          if (observationValue < minValue) return "Low";
          return "Normal";
        };

        const [selectedFlag, setSelectedFlag] = useState(
          row.original.flag || getFlag(),
        );

        useEffect(() => {
          const autoFlag = getFlag();
          setSelectedFlag(autoFlag);
          row.original.flag = autoFlag;
        }, [observationValue, minValue, maxValue]);

        const handleFlagChange = (e) => {
          const newFlag = e.target.value;
          setSelectedFlag(newFlag);
          row.original.flag = newFlag;
        };

        return isHeader ? (
          <span></span>
        ) : (
          <select value={selectedFlag} onChange={handleFlagChange}>
            <option value="Normal">Normal</option>
            <option value="High">High</option>
            <option value="Low">Low</option>
          </select>
        );
      },
    },
    {
      Header: "MacReading",
      accessor: "machine_reading",
      disableSortBy: true,
      Cell: ({ row }) => {
        return row.original.header ? (
          <span></span>
        ) : (
          <span>{row.original.machine_reading}</span>
        );
      },
    },
    {
      Header: "Unit",
      accessor: "unit",
      disableSortBy: true,
      Cell: ({ row }) => {
        return row.original.header ? (
          <span></span>
        ) : (
          <span>{row.original.unit}</span>
        );
      },
    },
    {
      Header: "MinValue",
      accessor: "min_reading",
      disableSortBy: true,
      Cell: ({ row }) => {
        return row.original.header ? (
          <span></span>
        ) : (
          <span>{row.original.min_reading}</span>
        );
      },
    },
    {
      Header: "MaxValue",
      accessor: "max_reading",
      disableSortBy: true,
      Cell: ({ row }) => {
        return row.original.header ? (
          <span></span>
        ) : (
          <span>{row.original.max_reading}</span>
        );
      },
    },
    {
      Header: "Display Reading",
      accessor: "display_reading",
      disableSortBy: true,
      Cell: ({ row }) => {
        const isHeader = row.original.header === true;

        const [displayReading, setDisplayReading] = useState(
          row.original.display_reading || "",
        );

        useEffect(() => {
          row.original.display_reading = displayReading;
        }, [displayReading, row.original]);

        const handleDisplayReadingChange = (e) => {
          const newValue = e.target.value;
          setDisplayReading(newValue);
          row.original.display_reading = newValue;
        };

        return isHeader ? (
          <span></span>
        ) : (
          <textarea
            style={{ resize: "both", overflow: "auto", width: "100%" }}
            value={displayReading}
            onChange={handleDisplayReadingChange}
          />
        );
      },
    },
    {
      Header: "Method",
      accessor: "method_name",
      disableSortBy: true,
      Cell: ({ row }) => {
        return row.original.header ? (
          <span></span>
        ) : (
          <span>{row.original.method_name}</span>
        );
      },
    },
  ];
};

export const INVESTIGATION_OBSERVATION_COLUMNS_DATA = (
  handleValue,
  inputRefs,
  lastFocusedInput,
) => {
  return [
    {
      Header: "Observation Name",
      accessor: "observation_obj.observation",
      disableSortBy: true,
      Cell: ({ row }) => {
        const isHeader = row.original.header === true;

        return (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "5px" }}
            >
              <span
                style={{
                  fontWeight: isHeader ? "bold" : "normal",
                  textTransform: isHeader ? "uppercase" : "none",
                  marginLeft: isHeader ? "-12px" : "0px",
                }}
              >
                {row.original.observation_obj.observation}
              </span>
            </div>
          </>
        );
      },
    },
    {
      Header: "Value",
      accessor: "observation_value",
      disableSortBy: true,
      Cell: ({ row }) => {
        const isHeader = row.original.header === true;
        const rowIndex = row.index;

        const [localValue, setLocalValue] = useState(
          row.original.observation_value || "",
        );
        const [showHelp, setShowHelp] = useState(false);
        const dropdownRef = useRef(null);
        const helpIconRef = useRef(null);

        const filteredHelp = row.original.observation_help
          ? row.original.observation_help.filter(
              (help) => help.observation_id === row.original.observation_id,
            )
          : [];

        useEffect(() => {
          if (
            row.original.observation_value !== localValue &&
            document.activeElement !== inputRefs.current[rowIndex]
          ) {
            setLocalValue(row.original.observation_value || "");
          }
        }, [row.original.observation_value, rowIndex]);

        useEffect(() => {
          row.original.observation_value = localValue;
        }, [localValue, row.original]);

        useEffect(() => {
          function handleClickOutside(event) {
            if (
              helpIconRef.current &&
              helpIconRef.current.contains(event.target)
            ) {
              return;
            }

            if (
              dropdownRef.current &&
              !dropdownRef.current.contains(event.target) &&
              showHelp
            ) {
              setShowHelp(false);
            }
          }

          if (showHelp) {
            document.addEventListener("mousedown", handleClickOutside);
          }

          return () => {
            document.removeEventListener("mousedown", handleClickOutside);
          };
        }, [showHelp]);

        const handleKeyDown = (e) => {
          const acceptableKeys = ["Tab", "Enter"];

          if (!acceptableKeys.includes(e.key)) return;

          if (e.key === "Enter" && filteredHelp.length > 0) {
            e.preventDefault();
            lastFocusedInput.current = e.target;
            setShowHelp(!showHelp);
            return;
          }

          if (
            e.key === "Tab" ||
            (e.key === "Enter" && filteredHelp.length === 0)
          ) {
            e.preventDefault();
            const direction = e.key === "Tab" && e.shiftKey ? -1 : 1;

            const currentIndex = inputRefs.current.findIndex(
              (el) => el === document.activeElement,
            );

            let nextIndex = currentIndex + direction;

            while (!inputRefs.current[nextIndex]) {
              nextIndex += direction;

              if (nextIndex >= inputRefs.current.length) {
                nextIndex = 0;
              } else if (nextIndex < 0) {
                nextIndex = inputRefs.current.length - 1;
              }
            }

            inputRefs.current[nextIndex]?.focus();
          }
        };

        const handleChange = (e) => {
          const newValue = e.target.value;
          setLocalValue(newValue);
          row.original.observation_value = newValue;
          handleValue(
            row.original.observation_id,
            newValue,
            row.original.investigation_id,
          );
        };

        const helpIconStyle = {
          backgroundColor: "#3b82f6",
          color: "white",
          borderRadius: "50%",
          width: "16px",
          height: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "12px",
          fontWeight: "bold",
          cursor: "pointer",
        };

        return isHeader ? (
          <span></span>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              position: "relative",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                gap: "5px",
              }}
            >
              <input
                ref={(el) => {
                  if (el && !inputRefs.current.includes(el)) {
                    inputRefs.current.push(el);
                  }
                }}
                type="text"
                value={localValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                onFocus={(e) => {
                  lastFocusedInput.current = e.target;
                }}
                style={{
                  backgroundColor: "white",
                  color: "black",
                  border: "1px solid #d9d9d9",
                  padding: "5px",
                  borderRadius: "4px",
                  outline: "none",
                }}
              />

              {showHelp && (
                <select
                  size={filteredHelp?.length}
                  ref={dropdownRef}
                  className="absolute z-10 bg-white border border-gray-200 rounded shadow-lg p-2 w-64"
                  style={{
                    top: "100%",
                    left: "0",
                    overflowY: "auto",
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      const selectedItem = filteredHelp.find(
                        (item) => item.id.toString() === e.target.value,
                      );
                      if (selectedItem) {
                        const valueToSet =
                          selectedItem.help_value || selectedItem.help_header;
                        setLocalValue(valueToSet);
                        setShowHelp(false);
                        row.original.observation_value = valueToSet;
                        handleValue(
                          row.original.observation_id,
                          valueToSet,
                          row.original.investigation_id,
                        );
                      }
                      setTimeout(() => {
                        lastFocusedInput.current?.focus();
                      }, 0);
                    }
                  }}
                  onClick={(e) => {
                    const selectedItem = filteredHelp.find(
                      (item) => item.id.toString() === e.target.value,
                    );
                    if (selectedItem) {
                      const valueToSet =
                        selectedItem.help_value || selectedItem.help_header;
                      setLocalValue(valueToSet);
                      setShowHelp(false);
                      row.original.observation_value = valueToSet;
                      handleValue(
                        row.original.observation_id,
                        valueToSet,
                        row.original.investigation_id,
                      );
                    }
                  }}
                  onBlur={() => setShowHelp(false)}
                  autoFocus
                >
                  {filteredHelp.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.help_header}
                    </option>
                  ))}
                </select>
              )}
            </div>

            {filteredHelp.length > 0 && (
              <div className="relative">
                <span
                  ref={helpIconRef}
                  style={helpIconStyle}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowHelp(!showHelp);
                  }}
                >
                  ?
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      Header: "MacReading",
      accessor: "observation_value_mac_reading",
      disableSortBy: true,
      Cell: ({ row }) => {
        const isHeader = row.original.header === true;
        const [localMacValue, setLocalMacValue] = useState(
          row.original.observation_value_mac_reading || "",
        );
        const handleKeyDown = (e) => {
          const acceptableKeys = ["Tab", "Enter"];
          // console.log("Pressed Key:", e.key);

          if (!acceptableKeys.includes(e.key)) return;

          e.preventDefault();
          const direction = e.key === "Tab" && e.shiftKey ? -1 : 1;
          // console.log("Direction:", direction);

          const currentIndex = inputRefs.current.findIndex(
            (el) => el === document.activeElement,
          );
          // console.log("Current Index:", currentIndex);

          let nextIndex = currentIndex + direction;
          // console.log("Initial Next Index:", nextIndex);

          while (!inputRefs.current[nextIndex]) {
            // console.log("Skipping invalid input at index:", nextIndex);
            nextIndex += direction;

            if (nextIndex >= inputRefs.current.length) {
              nextIndex = 0;
              // console.log("Wrapped to start:", nextIndex);
            } else if (nextIndex < 0) {
              nextIndex = inputRefs.current.length - 1;
              // console.log("Wrapped to end:", nextIndex);
            }
          }

          // console.log("Focusing on index:", nextIndex);
          inputRefs.current[nextIndex]?.focus();
        };

        const handleMacChange = (e) => {
          const newValue = e.target.value;
          setLocalMacValue(newValue);
          row.original.observation_value_mac_reading = newValue;
          handleValue(
            row.original.observation_id,
            newValue,
            row.original.investigation_id,
            "observation_value_mac_reading",
          );
        };

        return isHeader ? (
          <span></span>
        ) : (
          <input
            type="text"
            ref={(el) => {
              if (el && !inputRefs.current.includes(el)) {
                inputRefs.current.push(el);
              }
            }}
            value={localMacValue}
            onChange={handleMacChange}
            onKeyDown={handleKeyDown}
            style={{
              backgroundColor: "white",
              color: "black",
              border: "1px solid #d9d9d9",
              padding: "5px",
              borderRadius: "4px",
              outline: "none",
            }}
          />
        );
      },
    },
    {
      Header: "",
      accessor: "ids",
      disableSortBy: true,
      Cell: ({ row }) => {
        return;
        <span></span>;
      },
    },
  ];
};

export const COLUMN_DATA = ({
  temp,
  state,
  setState,
  handleViewModal,
  mergedArray,
  setTempone,
  orgtemp,
  setorgtemp,
}) => {
  const handleInputChange = (row, e) => {
    const value = e.target.value;
    const updatedState = state.map((item) =>
      item.investigation_id === row.investigation_id
        ? { ...item, remarks: value }
        : item,
    );
    const updatedOrgTemp = orgtemp.map((item) =>
      item.investigation_id === row.investigation_id
        ? { ...item, remarks: value }
        : item,
    );
    setState(updatedState);
    setorgtemp(updatedOrgTemp);
    updateRowInArray({ ...row, remarks: value });
  };

  const handleBarcodeChange = (row, e) => {
    const value = e.target.value;
    const updatedState = state.map((item) =>
      item.investigation_id === row.investigation_id
        ? { ...item, barcode_no: value }
        : item,
    );
    const updatedOrgTemp = orgtemp.map((item) =>
      item.investigation_id === row.investigation_id
        ? { ...item, barcode_no: value }
        : item,
    );
    setState(updatedState);
    setorgtemp(updatedOrgTemp);
    updateRowInArray({ ...row, barcode_no: value });
  };

  const handleCheckboxChange = (row, e) => {
    const checked = e.target.checked;
    const updatedState = state.map((item) =>
      item.investigation_id === row.investigation_id
        ? { ...item, ifDefault: checked }
        : item,
    );
    const updatedOrgTemp = orgtemp.map((item) =>
      item.investigation_id === row.investigation_id
        ? { ...item, ifDefault: checked }
        : item,
    );
    setState(updatedState);
    setorgtemp(updatedOrgTemp);
    updateRowInArray({ ...row, ifDefault: checked });
  };

  const handleSampleTypeChange = (row, e) => {
    const value = Number(e.target.value);
    const updatedState = state.map((item) =>
      item.investigation_id === row.investigation_id
        ? { ...item, selectedSampleTypeId: value }
        : item,
    );
    const updatedOrgTemp = orgtemp.map((item) =>
      item.investigation_id === row.investigation_id
        ? { ...item, selectedSampleTypeId: value }
        : item,
    );
    setState(updatedState);
    setorgtemp(updatedOrgTemp);
    updateRowInArray({ ...row, selectedSampleTypeId: value });
  };

  const updateRowInArray = (row) => {
    const existingRowIndex = temp.findIndex(
      (item) => item.investigation_id === row.investigation_id,
    );
    if (existingRowIndex !== -1) {
      temp[existingRowIndex] = { ...temp[existingRowIndex], ...row };
      setTempone([...temp]);
    } else {
      temp.push({ ...row, status: "COLLECTED" });
      setTempone([...temp]);
    }
  };

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  return [
    {
      Header: "Color Code",
      accessor: "container_colour_code",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return (
          <div
            style={{
              backgroundColor: cell.value,
              width: "100%",
              height: "40px",
            }}
          />
        );
      },
    },
    {
      Header: "Sample",
      accessor: "sample_type_obj",
      disableSortBy: true,
      Cell: ({ cell }) => {
        const { sample_type_obj, investigation_id } = cell.row.original;
        const selectedSampleTypeId =
          state.find((item) => item.investigation_id === investigation_id)
            ?.selectedSampleTypeId || "";
        const defaultSampleType = sample_type_obj?.find(
          (option) => option.if_default,
        );
        const isEmpty = !sample_type_obj || sample_type_obj.length === 0;

        return (
          <select
            style={{
              width: "120px",
              padding: "2px",
              borderRadius: "5px",
              borderColor: isEmpty ? "red" : "#DEE2E6",
              backgroundColor: isEmpty ? "#FFD6D6" : "white",
            }}
            value={
              selectedSampleTypeId ||
              (defaultSampleType ? defaultSampleType.sample_type_id : "")
            }
            onChange={(e) => handleSampleTypeChange(cell.row.original, e)}
            disabled={isEmpty}
          >
            {isEmpty ? (
              <option value="">No Sample Available</option>
            ) : (
              sample_type_obj.map((option, index) => (
                <option key={index} value={option.sample_type_id}>
                  {decodeHtml(option.sample_type)}
                </option>
              ))
            )}
          </select>
        );
      },
    },
    {
      Header: "Barcode",
      accessor: "barcode_no",
      disableSortBy: true,
      Cell: ({ cell }) => {
        const barcodeValue =
          state.find(
            (item) =>
              item.investigation_id === cell.row.original.investigation_id,
          )?.barcode_no || "";
        return (
          <input
            type="text"
            defaultValue={barcodeValue || cell.row.original.barcode_no || ""}
            onBlur={(e) => handleBarcodeChange(cell.row.original, e)}
            style={{ width: "120px" }}
          />
        );
      },
    },
    {
      Header: "Investigation",
      accessor: "investigation_name",
      disableSortBy: true,
    },
    {
      Header: "Remarks",
      accessor: "remarks",
      disableSortBy: true,
      Cell: ({ cell }) => {
        const remarksValue =
          state.find(
            (item) =>
              item.investigation_id === cell.row.original.investigation_id,
          )?.remarks || "";
        return (
          <input
            type="text"
            defaultValue={remarksValue}
            onBlur={(e) => handleInputChange(cell.row.original, e)}
            style={{ width: "120px" }}
          />
        );
      },
    },
    {
      Header: "View",
      accessor: "view",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return (
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => handleViewModal(cell.row.original, true)}
          >
            View
          </button>
        );
      },
    },
    {
      Header: "Default",
      accessor: "ifDefault",
      disableSortBy: true,
      Cell: ({ cell }) => {
        const isDefault = state.find(
          (item) =>
            item.investigation_id === cell.row.original.investigation_id,
        )?.ifDefault;

        return (
          <input
            type="checkbox"
            checked={isDefault}
            onChange={(e) => handleCheckboxChange(cell.row.original, e)}
          />
        );
      },
    },
  ];
};

export const DOCUMENT_FORM_CONFIG = (rowData) => [
  {
    label: "Document Name",
    type: "input-text",
    name: "document_name",
    defaultValue: rowData?.document_name || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
];

export const OPTIONS = [{ key: "document_name", value: "Document Name" }];

export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "Inactive" },
];

const today = new Date();
const yyyy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();

if (dd < 10) dd = "0" + dd;
if (mm < 10) mm = "0" + mm;

const formattedToday = yyyy + "-" + mm + "-" + dd;

today.setDate(today.getDate() - 1);
let yesterdayDd = today.getDate();
let yesterdayMm = today.getMonth() + 1;
const yesterdayYyyy = today.getFullYear();

if (yesterdayDd < 10) yesterdayDd = "0" + yesterdayDd;
if (yesterdayMm < 10) yesterdayMm = "0" + yesterdayMm;

const formattedYesterday =
  yesterdayYyyy + "-" + yesterdayMm + "-" + yesterdayDd;

export const FILTER_DEFINITIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
  {
    name: "from_date",
    type: FILTER_TYPE.SELECT,
    initialValue: formattedToday,
  },
  {
    name: "to_date",
    type: FILTER_TYPE.SELECT,
    initialValue: formattedToday,
  },
];
